import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy } from '../../stateless/copy';
import { AnswersRange } from '../../stateless/answers';
import HOCNextStepController from '../../hoc/next-step-controller';
import { NextButton } from '../../stateless/buttons';
import EconomicalScoreTrackerFourPlayer from '../../shared/economical-score-tracker-four-participants';
import ReviewResults from '../../shared/review-results';

const EnhancedButton = HOCNextStepController(NextButton);

/**
 * @class EconomicalRangeTimeMultiplier
 *
 * @description
 * Class for the EconomicalRangeTimeMultiplier question.
 *
 * @example
 * <EconomicalRangeTimeMultiplier />
 */
export default class EconomicalRangeTimeMultiplier extends Component {

	static PropTypes = {
		user: PropTypes.object,
		players: PropTypes.object,
		window: PropTypes.object,
		nextWindow: PropTypes.func,
		updateAnswer: PropTypes.func,
		updateSaveState: PropTypes.func,
		currentValue: PropTypes.string,
		countryCode: PropTypes.string
	};

	static defaultProps = {};

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	componentWillReceiveProps (nextProps) {
		if (this.props.currentValue !== nextProps.currentValue) {
			this.calculateResult(nextProps);
		}
	}

	calculateResult (newProps) {
		const { max } = newProps.window.current.answers.range;
		const { poolResources, multiplier, playerBaseTimeInvestment } = newProps.window.current.answers;
		let { currentValue } = newProps;
		let baseRes = poolResources + currentValue * multiplier;
		let newState = {};
		let newScore;

		for (let [key] of Object.entries(this.props.players)) {

			if (playerBaseTimeInvestment[key]) {
				newScore = (baseRes / 4) + ((max - playerBaseTimeInvestment[key]) * 100);
			} else {
				newScore = (baseRes / 4) + ((max - currentValue) * 100);
			}

			newState[key] = { resources: Math.round(newScore)};
		}

		this.props.updateSaveState({ players: newState });
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const {
			user,
			window,
			countryCode,
			updateAnswer,
			currentValue,
			players
		} = this.props;

		return (
			<div>
				<Copy user={user} window={window} countryCode={countryCode} players={players}>

					<EconomicalScoreTrackerFourPlayer {...this.props} {...this.state} unit={'€'} isTime={true} multiplier={50} poolName={this.props.translations.dockPromotion[this.props.countryCode]} />

					{
						(window.current && window.current.reviewResults) &&
						<ReviewResults />
					}

					{
						window.current.answers &&
						<AnswersRange range={window.current.answers.range} updateAnswer={updateAnswer} currentValue={currentValue}/>
					}
					<EnhancedButton
						{ ...this.props }
						hasResources={ true }
					/>
				</Copy>
			</div>
		);
	}
}
